import { render, staticRenderFns } from "./dvider.vue?vue&type=template&id=10e84f64"
import script from "./dvider.vue?vue&type=script&lang=js"
export * from "./dvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports